import type { JSX } from 'react';
import { Button } from '@mui/material';

import s from './SecondaryButton.module.css';

type SecondaryButtonProps = {
  title?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  customClass?: string;
  icon?: JSX.Element;
  onClick: () => void;
};

function SecondaryButton({
  title,
  isDisabled,
  isLoading,
  customClass,
  icon,
  onClick,
}: SecondaryButtonProps) {
  return (
    <Button
      variant="outlined"
      disabled={isDisabled || isLoading}
      loading={isLoading}
      className={`${s.secondaryButton} ${icon ? s.icon : ''} ${customClass || ''}`}
      onClick={onClick}>
      {icon && icon}
      {title && <p className={s.buttonText}>{title}</p>}
    </Button>
  );
}

export default SecondaryButton;
